import Lightbox from './bs5-lightbox';

const options = {
	keyboard: true
};

document.querySelectorAll('[data-toggle="lightbox"], .wp-block-image a[href*="vimeo.com"]').forEach((el) => el.addEventListener('click', (e) => {
	e.preventDefault();
	const lightbox = new Lightbox(el, options);
	lightbox.show();
}));
//
// import Swiper JS
import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';

const swiper = new Swiper('.swiper', {
    // Optional parameters
    //direction: 'vertical',
	modules: [Autoplay, Navigation, Pagination],
    loop: true,
	slidesPerView: 1,
	breakpoints: {
		992:{
			slidesPerView: 2,
			spaceBetween: 24
		}
	},
	autoHeight: true, // Make slides equal height
	autoplay: {
		delay: 10000,
	},
	// Navigation arrows
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
});



//
// Back to Top Button
var mybutton = document.getElementById("btn-back-to-top");

window.addEventListener('scroll', function() {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        mybutton.style.display = "block";
    } else {
        mybutton.style.display = "none";
    }

    //resizeLogo(); // Call the resizeLogo function on scroll
});

mybutton.addEventListener("click", function() {
    jQuery("html, body").animate({ scrollTop: 0 }, "slow");
});

function resizeLogo() {
    const logo = document.querySelector('.custom-logo-link img');
    if (window.scrollY > 20) {
        logo.classList.add('small-logo');
    } else {
        logo.classList.remove('small-logo');
    }
}
//
jQuery(document).ready(function($) {
	$('#events-filter').submit( function(e) {
		e.preventDefault();
		var eventType = $('#event-type').val();
		$.ajax({
			type: 'POST',
			url: '/wp-admin/admin-ajax.php',
			data : {action: "filter_events", eventType: eventType},
			beforeSend:function(xhr) {
				$("#site-overlay").show();
			},
			success: function(response) {
				var result = $.parseJSON(response);
				if(result.flag == 1) {
					$(".wp-block-lazyblock-events .loop").html(result.data);
				//	$(".wp-block-lazyblock-event-query .row .pagination").html(result.pagination);
				}
				else {
					var html = '<div class="col-12 mb-5"><p>Sorry, no events matched your search.</p></div>';
					$(".wp-block-lazyblock-events .loop").html(html);
				//	$(".wp-block-lazyblock-event-query .row .pagination").empty();
				}
			},
			complete:function(data) {
				$("#site-overlay").hide();
			},
			error: function(xhr, status, error){
				console.log(error);
			}
		});
	});
	//
	if (window.location.hash) {
		// Store the hash
		var hash = window.location.hash;

		// Adjusting for the sticky header height
		if (window.matchMedia("(min-width:992px)").matches) {
			var headerHeight = $('.sticky-lg-top').outerHeight();
		}
		else{
			var headerHeight = 0;
		}
	
		// Wait for the DOM to be fully loaded and then scroll to the element
		if ($(hash).length) {
			$('html, body').animate({
				scrollTop: $(hash).offset().top - headerHeight
			}, 'slow', function() {
                // Use history.replaceState() to remove the hash from the address bar
                history.replaceState(null, null, ' ');
            });
		}
	}
});